var map = {
	"./logos/logo-brang.png": "./src/assets/logos/logo-brang.png",
	"./logos/logo-creditvisor-small.png": "./src/assets/logos/logo-creditvisor-small.png",
	"./logos/logo-creditvisor.png": "./src/assets/logos/logo-creditvisor.png",
	"./logos/logo-uuva-cloud-cloud.png": "./src/assets/logos/logo-uuva-cloud-cloud.png",
	"./logos/logo-uuva-cloud-small.png": "./src/assets/logos/logo-uuva-cloud-small.png",
	"./logos/logo-uuva-cloud.png": "./src/assets/logos/logo-uuva-cloud.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets sync recursive ^\\.\\/.*\\.png$";